import React from "react";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";

import { useNavigate } from "react-router-dom";

import BackIcon from "../../../../assets/svg/BackIcon";
import EvolutionGames from "../../../../assets/images/provider/evolution1.jpg";
import EzugiGames from "../../../../assets/images/provider/Ezugi.jpg";
import AppuGames from "../../../../assets/images/provider/Supernowa.jpg";
import XPG from "../../../../assets/images/provider/XPG.jpg";
import WorldCasino from "../../../../assets/images/provider/WorldCasino1.jpg";
import Slots from "../../../../assets/images/provider/SLot.jpg";
import Exchange from "../../../../assets/images/provider/Sports.jpg";
import Qtech from "../../../../assets/images/provider/Qtech.jpg";
import Vivo from "../../../../assets/images/provider/Vivo.jpg";
import Pragmaticplay from "../../../../assets/images/provider/Pragmaticplay.webp";

const LiveDealer = () => {
  const navigate = useNavigate();
  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <div className="container">
          <div className="live-deal-section">
            <div className="pagesHeading">
              <h2 className="sectionTitle border-0">Live Dealer</h2>
              <div className="back-link" onClick={() => navigate(-1)}>
                Back <BackIcon />
              </div>
            </div>
            <ul>
              <li>
                <a href="/casino/evolution">
                  <img src={EvolutionGames} alt="Providers Logo" />
                </a>
              </li>
              <li>
                <a href="/casino/ezugi">
                  <img src={EzugiGames} alt="Providers Logo" />
                </a>
              </li>
              <li>
                <a href="/casino/supernowa">
                  <img src={AppuGames} alt="Providers Logo" />
                </a>
              </li>
              <li>
                <a href="/casino/xpg">
                  <img src={XPG} alt="Providers Logo" />
                </a>
              </li>
              <li>
                <a href="/casino/worldcasino">
                  <img src={WorldCasino} alt="Providers Logo" />
                </a>
              </li>
              <li>
                <a href="/slots">
                  <img src={Slots} alt="Providers Logo" />
                </a>
              </li>
              <li>
                <a href="/casino/qtech">
                  <img src={Qtech} alt="Providers Logo" />
                </a>
              </li>
              <li>
                <a href="/casino/vivo">
                  <img src={Vivo} alt="Providers Logo" />
                </a>
              </li>
              <li>
                <a href="/pragmaticplay">
                  <img src={Pragmaticplay} alt="Pragmaticplay Logo" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default LiveDealer;
